import jwtDecode from "jwt-decode";
export const getUserIdFromToken = (token) => {
    const payload = jwtDecode(token);
    const hasuraClaims = payload["https://hasura.io/jwt/claims"];
    const userId = hasuraClaims ? hasuraClaims["x-hasura-user-id"] : "";
    return userId;
};
//# sourceMappingURL=jwtUtils.js.map